import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { SERVER, ESTADOS_FORM } from 'skrit-web-framework/constantes';
//import * as Sentry from '@sentry/browser';
import { pickBy } from 'lodash';
import 'whatwg-fetch';

import store from './store/index.js';
import App from './components/App.jsx';

require('../Styles/sass/main.scss');

window.addEventListener(
    'load',
    () => {
        if (document.visibilityState !== 'prerender') {
            let counter = parseInt(localStorage.getItem('tabCount'), 10) || 0;
            localStorage.setItem('tabCount', counter + 1);
        }
    },
    false
);

window.onbeforeunload = function(e) {
    let confirmationMessage = 'o/';
    let counter = Math.max(
        parseInt(localStorage.getItem('tabCount'), 10) - 1,
        0
    );
    localStorage.setItem('tabCount', counter.toString());
    let editForms = pickBy(
        store.getState().forms,
        value => value.estado === ESTADOS_FORM.EDICION
    );

    if (counter === 0 || Object.keys(editForms).length > 0) {
        localStorage.setItem('isLogged', 'false');
        fetch(SERVER + '/Login/SalirAplicacion', { credentials: 'include' });
        e.returnValue = confirmationMessage;
        return confirmationMessage;
    }
};

/**
 * TODO: Comment this section if you do not want to activate error tracking.
 * Initialize Sentry (error tracking service)
 */
// Sentry.init({
//     dsn: process.env.SENTRY_DSN,
//     release: process.env.VERSION
// });

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);
